import React from "react";
import { AlertTriangle, Users, FileSignature, TrendingUp, MessageCircle, CalendarDays, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLang, translateFr as tfr } from "@/i18n";

const PROMPTS = [
  { icon: AlertTriangle, tone: "text-athlynx", label: tfr("Que dois-je prioriser cette semaine ?") },
  { icon: Users, label: tfr("Quels athlètes dois-je relancer ?") },
  { icon: FileSignature, label: tfr("Quels contrats arrivent à échéance ?") },
  { icon: TrendingUp, label: tfr("Quelles opportunités dois-je faire avancer ?") },
  { icon: MessageCircle, label: tfr("Quelles relations nécessitent mon attention ?") },
  { icon: CalendarDays, label: tfr("Prépare mon prochain rendez-vous") },
];

export const StarterPrompts = ({ onPick, disabled }) => {
  const { tf } = useLang();
  return (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5" data-testid="intel-starter-prompts">
    {PROMPTS.map(({ icon: Icon, tone, label }, i) => (
      <button
        key={label}
        onClick={() => onPick(label)}
        disabled={disabled}
        data-testid={`intel-starter-${i}`}
        className={cn(
          "group flex items-center gap-2.5 rounded-xl border border-border/80 bg-transparent px-3.5 py-3 text-left",
          "text-[13px] font-medium text-foreground/85 transition-colors duration-150",
          "hover:bg-secondary/40 hover:border-foreground/20 hover:text-foreground",
          "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:opacity-50"
        )}
      >
        <Icon className={cn("h-4 w-4 shrink-0", tone || "text-muted-foreground")} aria-hidden="true" />
        <span className="flex-1 leading-snug">{tf(label)}</span>
        <ChevronRight className="h-3.5 w-3.5 shrink-0 text-muted-foreground/40 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" />
      </button>
    ))}
  </div>
);
};
